module.exports = "<h1 *ngIf=\"pageHeadline\" class=\"{{headlineCssClass}}\">{{pageHeadline}}</h1>\n\n<h2 *ngIf=\"boxHeadline && !boxHeadlineLink\" class=\"box-headline\">{{boxHeadline}}</h2>\n\n<h2 *ngIf=\"boxHeadlineLink && boxHeadline\" class=\"box-headline\"><a [routerLink]=\"boxHeadlineLink\">{{boxHeadline}}</a></h2>\n\n<div class=\"{{boxCssClass ? boxCssClass : 'box'}}\">\n\t<ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/leo-box/leo-box.html
// module id = PWMw
// module chunks = 12